import React, { useEffect, useState } from "react";
import { propTypes } from "react-bootstrap/esm/Image";
import { useDispatch } from "react-redux";
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory";
import { getConfiguredLabel, renderFileIconClass } from "../../common/commonHelper";
import { DataTypes, TemplateTypes } from "../../common/constants";
import { cancelButton, DocumentsPage, updateSupported } from "../../common/labelConstants";
import { usePermissions } from "../../hooks/usePermissions";
import { getUploadConfig } from "../../store/config/configSlice";
import { getTemplate } from "../../store/template/templateSlice";
import { ComponentLoader } from "../loader/componentLoader";
import UploadFile from "./filePond";
import { SaveFilesButton } from "./saveFilesButton";
import { createFileObject } from "./uploadHelper";
import { IconTypes, RenderIcons } from "../controls/icons";
import { humanFileSize } from "../../helpers/fileHelper";
import mime from "mime";

function Upload(props) {
    const dispatch = useDispatch();
    const [isMounted, setIsMounted] = useState(true);
    const [config, setConfig] = useState();
    const [controls, setControls] = useState();
    const slbSearchConfig = window.slbConfig;
    const permissions = usePermissions();
   
    useEffect(() => {
        const request = { clientId: slbSearchConfig.accountId}
        let promise = dispatch(getUploadConfig(request))
        promise.then((res) => {
            if(isMounted && res?.payload?.data)
                setConfig(res.payload.data);
        })
        return () => {
            setIsMounted(false)
            if (promise && typeof promise.abort == 'function')
                promise.abort()
        }
    }, [])


    useEffect(() => {
        let data = {
            clientId: "0",
            dataType_id: DataTypes.Documents.id,
            templateName: TemplateTypes.UploadMetadata
        }
        dispatch(getTemplate(data)).then((res) => {
            
            if (isMounted && res.payload.status === 200) {
                setControls( res.payload?.data?.data)
            }
        })
        return () => {
            setIsMounted(false)
        }
    }, [])

 
    return permissions.Edit && config && controls ? <UploadFile
        cancel={(onCancelClick) => {
            return <button type="button" className="btn btn-primary calcel_btn" onClick={onCancelClick}>{getConfiguredLabel(DocumentsPage, cancelButton)}</button>
        }}
        save={({allFilesProcessed, metadataForm, fileList, onSaveSuccess, getFileErrors }) => {
            return <SaveFilesButton
            getFileErrors={getFileErrors}
            allFilesProcessed={allFilesProcessed} metadataForm={metadataForm} fileList={fileList} onSaveSuccess={onSaveSuccess} variant="light"   config={config}  />
        }}
        setFilesCb={props.setFilesCb }
        metadataControls = {controls}
        allowFileRename={true} allowFileTagging={true} config={config} /> : <ComponentLoader />;
}

export default Upload

export const UpdateDocController = ({ field, fieldState, controlConfig = { type: '' }, className, setIsUploadComplete, existingDocInfo }) => {
    const dispatch = useDispatch();
    const slbSearchConfig = window.slbConfig;
    const [isMounted, setIsMounted] = useState(true);
    const [config, setConfig] = useState();
    const [file, setFile] = useState();
    const [showPond, setShowPond] = useState(false);
    const [uploadComplete, setUploadComplete] = useState(false);
    const allowedMimeTypeForUpdate = [mime.getType(existingDocInfo?.fileExtension)];

    useEffect(() => {
        const request = { clientId: slbSearchConfig.accountId}
        let promise = dispatch(getUploadConfig(request))
        promise.then((res) => {
            if(isMounted && res?.payload?.data)
                setConfig({...res.payload.data,...res.payload.data.updateDoc, allowedMimeTypes : allowedMimeTypeForUpdate, supportedFilesMsg : getConfiguredLabel(DocumentsPage,updateSupported)+existingDocInfo?.fileExtension});
        })
        return () => {
            setIsMounted(false)
            if (promise && typeof promise.abort == 'function')
                promise.abort()
        }
    }, [])

    useEffect(()=>{
        if(uploadComplete){
            field.onChange(createFileObject({file:file[0]?file[0]:""}))
            setIsUploadComplete(file[0]?true:false)
        }
    },[uploadComplete, file])
    
    const setFileCb =(arr)=>{
        setFile(arr)
    }

    const setUploadCompleteCb=(isProcessed)=>{
        setUploadComplete(isProcessed)
    }

    return !showPond ? (
      <div className="rc_update-doc-container">
        <div className="drag_wrapper Bulk_drag_wrapper rc_static_upload_view with_files">
        <div className="container">
          <div className="uploaded_file ">
            <div className="row">
              <div className="col-md-12">
                <div className="uploaded_file_left pos_relative upload_completed_file">
                  <div className="col_1">
                    <span className="doc_icon">
                      <span className={renderFileIconClass(existingDocInfo?.fileExtension)}></span>
                    </span>
                  </div>
                  <div className="col_2">
                    <div className="file_details">
                      <div className="file_name">
                        {existingDocInfo?.fileName}.{existingDocInfo?.fileExtension}
                      </div>
                      <div className="file_size">{humanFileSize(existingDocInfo?.fileSize)}</div>
                    </div>
                  </div>
                  <div className="col_3 text-center">
                    <span className="close_file_icon" onClick={() => {
                        setShowPond(true)
                        setIsUploadComplete(false)
                    }}>
                      {RenderIcons(IconTypes.DeleteIcon_File)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    ) : (
      <div className={"rc_update-doc-container " + className}>
        {config && (
          <UploadFile
            setFilesCb={setFileCb}
            config={config}
            isDocUpdate={true}
            docUpdateAllowedExtension={existingDocInfo?.fileExtension}
            setIsUploadComplete={setIsUploadComplete}
            setUploadCompleteCb={setUploadCompleteCb}
          />
        )}
      </div>
    );       
}

